<template>
  <div class="language-switcher">
    <div class="dropdown is-right" :class="{ 'is-active': isActive }">
      <div class="dropdown-trigger">
        <button
          class="button"
          aria-haspopup="true"
          aria-controls="language-switcher"
          @click="isActive = !isActive"
        >
          <span>{{ activeLocale.label }}</span>
          <span class="icon is-small">
            <i class="material-icons" aria-hidden="true">&#xE5C5;</i>
          </span>
        </button>
      </div>
      <div class="dropdown-menu" id="language-switcher" role="menu">
        <div class="dropdown-content">
          <a
            href="#"
            class="dropdown-item"
            v-for="item in locales"
            :key="item.value"
            @click="setLocale(item.value)"
          >{{ item.label }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import i18n from 'services/i18n';

export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      isActive: false,
    };
  },
  computed: {
    ...mapGetters('account', ['locale', 'locales']),
    activeLocale() {
      const activeLocale = this.locales.find(
        item => item.value === this.locale
      );

      if (!activeLocale) {
        return this.locales.find(item => item.value === i18n.fallbackLocale);
      }

      return activeLocale;
    },
  },
  methods: {
    setLocale(value) {
      this.isActive = false;

      if (value === this.locale) {
        return;
      }

      this.$store
        .dispatch('account/setLocale', value)
        .then(res => console.log(`Setting locale: ${value}`));
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.button {
  display: flex;
  height: 2.5rem;
  border-right: 1px solid rgba($black, 0.08);
  padding: 0.6875rem 1.125rem;
  font-size: 0.6875rem;
  font-weight: $weight-medium;
  color: rgba($black, 0.64);
  letter-spacing: 2.3px;
  text-transform: uppercase;
}

.dropdown-menu {
  margin-top: 1px;
}

.dropdown-item {
  padding: 0.6875rem 1.125rem;
  font-size: 0.6875rem;
  letter-spacing: 2.3px;
}
</style>